export const daDK = {
  app: {
    categories: {
      convectors: 'Konvektorer',
      decorative: 'Design',
      electric: 'Elektriske',
      panels: 'Paneler',
      towel: 'Håndklædetørrere',
    },
    categoryLabel: 'Kategori',
    categoryPlaceholder: 'Vælg en kategori',
    errorCategories: 'Kunne ikke indlæse kategorier.',
    errorPanels: 'Kunne ikke indlæse radiatorer.',
    loadingCategories: 'Indlæser kategorier...',
    loadingPanels: 'Indlæser radiatorer...',
    panelLabel: 'Radiatorer',
    panelPlaceholder: 'Vælg en radiator',
    titles: {
      convectors: 'Konvektor-beregner',
      decorative: 'Designradiator-beregner',
      electric: 'El-radiator-beregner',
      panels: 'Panelradiator-beregner',
      towel: 'Håndklædevarmer-beregner',
    },
  },
  calc: {
    actionButton: 'Vis beregnede produkter',
    boost: 'Boost-tilstand',
    calculateRequiredButton: 'Beregn påkrævet effekt',
    calculating: 'Beregner...',
    comfort: 'Komfort-tilstand',
    downloadLabel: 'Download data ({count})',
    emptyResults: 'Ingen resultater endnu.',
    errorMatch: 'Kunne ikke beregne resultater.',
    errorTypes: 'Kunne ikke indlæse radiatortyper.',
    flowTemp: 'Fremløb C°',
    height: 'Højde',
    length: 'Længde',
    loadingTypes: 'Indlæser typer...',
    modeLabel: 'Tilstand',
    modes: {
      cooling: 'Køling',
      heating: 'Opvarmning',
    },
    radiatorType: 'Radiatortype',
    requiredWatts: 'Påkrævet effekt (W)',
    resultsMessage: '{count} produkter tilgængelige for valgte indstillinger.',
    returnTemp: 'Returløb C°',
    roomTemp: 'Rumtemperatur C°',
    selectAllLabel: 'Vælg alle produkter',
    selectItemLabel: 'Vælg produkt til download',
    selectPanel: 'Vælg en radiator for at beregne.',
    standby: 'Standby-tilstand',
    tableHeaders: {
      calculatedWattage: 'Effekt',
      co2Equivalent: 'CO2-ækvivalent pr. kg materiale',
      depth: 'Dybde [mm]',
      description: 'Produktbeskrivelse',
      dop: 'DoP',
      eudop: 'EU DoP',
      height: 'Højde [mm]',
      itemId: 'Produktkode',
      length: 'Længde [mm]',
      waterContent: 'Vandindhold',
      weight: 'Vægt',
    },
    title: 'Beregninger',
    tolerance: 'Tolerance',
    typeCooling: 'Køling',
    typeGroupLabel: 'Type',
    typeHeating: 'Opvarmning',
  },
  existingRadiator: {
    description:
      'Denne beregner er kun til orientering. Konsulter altid en professionel installatør for den nøjagtige beregning før køb af radiatoren.',
    height: 'Radiatorhøjde',
    length: 'Radiatorlængde',
    resultLabelTemplate: 'Varmeeffektbehov, beregnet ved {temp} systemtemperatur',
    select: 'Vælg',
    temperature: 'Systemtemperatur',
    type: 'Radiatortype',
  },
  matrixCalc: {
    axisHeight: 'Højde (mm)',
    axisLength: 'Længde (mm)',
    axisType: 'Type',
    calculateButton: 'Calculate',
    displayLabel: 'Visning',
    exportExcel: 'Eksportér til Excel',
    exportPdf: 'Eksportér til PDF',
    print: 'Udskriv',
    hideOutOfRange: 'Skjul varer uden for intervallet',
    showAll: 'Vis alle',
    loading: 'Loading...',
    lockHeight: 'Højde',
    lockLabel: 'Lås dimension',
    lockLength: 'Længde',
    lockType: 'Type',
    noData: 'Select a radiator and click Calculate to view the matrix.',
    noItem: '—',
    noType: '—',
    targetOutput: 'Target output (W)',
    title: 'Matrix Calculator',
    tolerance: 'Tolerance (%)',
  },
  roomCalc: {
    actionButton: 'Beregn',
    clearButton: 'Ryd alt',
    fields: {
      ceilingHeight: 'Loftshøjde',
      doorInsulation: 'Dørisolering',
      floorInsulation: 'Gulvisolering',
      glazingArea: 'Glasareal',
      glazingMode: 'Glasareal',
      glazingQuality: 'Glaskvalitet',
      length: 'Længde',
      outerWalls: 'Ydervægge',
      projectedDesignTemp: 'Dimensionerende udetemperatur',
      roofInsulation: 'Tagisolering',
      roomArea: 'Rumareal',
      roomFloor: 'Etage',
      roomInsulation: 'Rumisolering',
      roomPreset: 'Rumtype',
      roomTemperature: 'Rumtemperatur',
      roomType: 'Rumtype',
      uncertaintyFactor: 'Usikkerhedsfaktor',
      ventilation: 'Ventilationsniveau',
      wallInsulation: 'Vægisolering',
      width: 'Bredde',
      windConditions: 'Vindforhold',
      windowInsulation: 'Vinduesiolering',
    },
    intro:
      'Denne beregner er kun til orientering. Konsulter altid en professionel installatør for den nøjagtige beregning før køb af radiatoren.',
    options: {
      glazing: {
        m2: 'm²',
        percent: '%',
      },
      glazingBands: {
        high: 'Mere end 20%',
        low: 'Mindre end 10%',
        mid: '10-20%',
      },
      glazingValue: {
        above_20: 'Over 20%',
        below_10: 'Under 10%',
        from_10_to_20: 'Fra 10% til 20%',
        no_windows: 'Uden vinduer',
      },
      insulationValue: {
        good: 'God',
        medium: 'Middel',
        poor: 'Dårlig',
        very_good: 'Meget god',
      },
      qualityValue: {
        modern_excellent: 'Moderne, fremragende energieffektivitet',
        modern_good: 'Moderne, god energieffektivitet',
        old_poor: 'Gamle, meget dårlig energieffektivitet',
        traditional_medium: 'Traditionelle, middel energieffektivitet',
      },
      roomValue: {
        bathroom_24: 'Badeværelse (24 C°)',
        bedroom_20: 'Soveværelse (20 C°)',
        garage_12: 'Garage (12 C°)',
        livingroom_22: 'Stue (22 C°)',
        storage_16: 'Opbevaring (16 C°)',
      },
      select: 'Vælg',
      storeyValue: {
        ground_multi: 'Stueetage (fleretagers bygning)',
        ground_single: 'Stueetage (etplans bygning)',
        interim: 'Mellemste etage',
        top_multi: 'Øverste etage (fleretagers bygning)',
      },
      temp: {
        climate_zone_1: 'DUT -12 C° (Kystområde)',
        climate_zone_2: 'DUT -13 C°',
        climate_zone_3: 'DUT -14 C°',
        climate_zone_4: 'DUT -15 C°',
        climate_zone_5: 'DUT -16 C°',
        climate_zone_6: 'DUT -17 C° (Indlandsområde)',
      },
      windInfluence: {
        normal: 'Normal',
        strong: 'Stærk',
        weak: 'Svag',
      },
    },
    roomPresets: {
      bathroom: 'Badeværelse',
      bedroom: 'Soveværelse',
      garage: 'Garage',
      kitchen: 'Køkken',
      living: 'Stue',
      storage: 'Opbevaring',
    },
    sections: {
      dimensions: 'Rumdimensioner',
      insulation: 'Isolering',
      placement: 'Placering',
      result: 'Resultat',
      temps: 'Temperaturer',
      ventilation: 'Ventilation',
    },
    title: 'Rumvarmetabs-beregner',
    units: {
      celsius: 'C°',
      meter: 'm',
      percent: '%',
      squareMeter: 'm²',
      watts: 'W',
    },
    useButton: 'Brug',
  },
  slider: {
    from: 'Fra',
    to: 'Til',
    value: 'Værdi',
  },
}
